module.exports = __webpack_public_path__ + "static/img/cf.2171101e.svg";